import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, boolean, mixed, object, string } from "yup";
import "Forms/Schemas/customMethods";

export type LoanExpenseCustomItem = {
  expenseItemID?: string | null;
  type?: string;
  installment?: string;
  balance?: string;
  institution?: string;
  belongsTo?: string;
  relatedAssetItemID?: string | null;
  id?: string | null;
};

export type LoanExpenseFormType = {
  readonly aggregatedAmount?: string;
  readonly detailed?: boolean;
  readonly customItems?: LoanExpenseCustomItem[];
};

export const getLoanExpenseFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<LoanExpenseFormType> = (t) => {
  const customItemSchema = object({
    id: string().nullable().notRequired(),
    expenseItemID: string().nullable().notRequired(),
    type: string().required(t(Resources.Validation.Required)),
    installment: string()
      .required(t(Resources.Validation.Required))
      .greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 })),
    balance: string().optional(),
    institution: string().optional(),
    belongsTo: string().optional(),
    relatedAssetItemID: string().notRequired(),
  });

  return object({
    detailed: boolean().optional(),

    aggregatedAmount: string().when(["detailed"], ([detailed], schema) =>
      !detailed
        ? schema.required(t(Resources.Validation.Required)).greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 }))
        : schema.optional(),
    ),

    customItems: array().when(["detailed"], ([detailed], schema) => {
      return detailed ? schema.of(customItemSchema).optional() : mixed().notRequired();
    }),
  }).defined();
};
